import { validateEmailField } from "../registrationHelpers";

export function validateCorporateContactForm(contactForm) {
  const errors = {};
  if (!contactForm.full_name?.trim()) {
    errors.full_name = "Required";
  }

  const emailResult = validateEmailField(contactForm.email || "");
  if (!emailResult.isValid) {
    errors.email =
      emailResult.error === "Please enter a valid email address"
        ? "Invalid email"
        : emailResult.error || "Required";
  }

  return errors;
}
